// Formato de importes del cotizador aéreo/marítimo («$ 18,500 MXN»).
const moneyFmt = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 });

export function formatMoney(amount: number, currency = "MXN"): string {
  return `$ ${moneyFmt.format(Math.round(amount))} ${currency}`;
}
